/* @ngInject */
function guestService (Utils, CONSTANTS, ConnectorWebService) {
  const service = {
    getAssetPacks,
    getGuestSummary
  }
  return service

  function getAssetPacks (userId, params) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK_SHARED, [userId])

    if (params) {
      url = Utils.fnAddQueryToUrl(url, params)
    }

    return ConnectorWebService.get(url)
  }

  function getGuestSummary (userId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_GUESTS_SUMMARY, [userId])
    return ConnectorWebService.get(url)
  }
}

export { guestService }
